module.exports = __webpack_public_path__ + "img/leftArrow.2b1a33f9.svg";